import React from 'react';
import {View} from 'react-native';
import {noop} from 'lodash';

import Icon from '/component/base/Icon';
import Text from '/component/base/Text';
import {Rank} from '/constant/TestIDs';
import {withCompetency, withTheme} from '/provider/ThemeProvider';
import {white} from '/theme/color/on.color';
import {mineShaft} from '/theme/color/secondary.color';
import {withHOC} from '/util/hoc.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './CoachRankMonthBox.style';

interface CoachRankMonthBoxProps {
  isChecked: boolean;
  month: string;
  getTheme: (key: string) => string;
  key: number | null;
  isLineThrough: boolean;
  noStyle: boolean;
  showIncentiveUpdate: boolean;
  isEligibleFutureMonth: boolean;
}

export const CoachRankMonthBox: React.FC<CoachRankMonthBoxProps> = ({
  key = null,
  month = '',
  isChecked = false,
  isLineThrough = false,
  noStyle = false,
  getTheme = noop,
  showIncentiveUpdate = false,
  isEligibleFutureMonth = false,
}: CoachRankMonthBoxProps) => {
  const defaultBoxStyle = showIncentiveUpdate ? styles.boxUpdated : styles.box;

  const checkedBoxStyle = {
    ...defaultBoxStyle,
    backgroundColor: getTheme('competency.textColor.color'),
  };
  const eligibleFutureMonthCheckboxStyle = {
    ...defaultBoxStyle,
    ...styles.futureMonthCheckboxStyle,
  };

  const boxStyle = noStyle
    ? defaultBoxStyle
    : isChecked
    ? checkedBoxStyle
    : isEligibleFutureMonth
    ? eligibleFutureMonthCheckboxStyle
    : {...defaultBoxStyle, ...styles.notFilledBox};

  const monthStyle = {
    ...styles.month,
    color: isChecked ? white : mineShaft,
    textDecorationLine: isLineThrough ? 'line-through' : 'none',
  };
  return (
    <View
      style={boxStyle}
      key={key}
      testID={Rank.rankMonthView}
      {...testProperties(Rank.rankMonthView)}>
      <View style={styles.content} {...testProperties(Rank.rankMonth)}>
        <Text
          style={monthStyle}
          variant="caption"
          {...testProperties(
            `${Rank.rankMonth}${isChecked ? '-checked' : '-unchecked'}`,
          )}>
          {month}
        </Text>
        {isChecked && (
          <Icon
            style={styles.icon}
            name="check"
            testID={`${Rank.rankMonthIcon}${
              isChecked ? 'checked' : 'unchecked'
            }`}
          />
        )}
      </View>
    </View>
  );
};

export const CoachRankMonthBoxConnected = withHOC(
  withTheme,
  withCompetency,
)(CoachRankMonthBox);
